import * as React from "react";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import {RNDatePicker} from "shared/controls/SingleInputs/RNDatePicker/RNDatePicker";
import {SpinnerButton} from "shared/controls/SpinnerButton";
import {faSearch} from "@fortawesome/free-solid-svg-icons/faSearch";
import {WpAjaxPost} from "shared/core/ajax/WPAjaxPost";
import {WPTable} from "shared/controls/WPTable/WPTable";
import {WPBasicColumn} from "shared/controls/WPTable/Columns/WPBasicColumn";
import * as moment from "moment";
import {ToastService} from "shared/core/services/ToastService";
import 'shared/styles/bootstrapminimal.scss';
export enum SearchBy {
    ConfirmationNumber='Confirmation Number',
    ArrivalDateRange='Arrival Date Range',
    DepartureDateRange='Departure Date Range',
    ArrivalDate='Arrival Date',
    DepartureDate='Departure Date'
}

export class App extends React.Component<AppProps, AppState> {
    static defaultProps: Partial<AppProps> = {};

    constructor(props: AppProps) {
        super(props);
        this.state = {
            ConfirmationNumber:'',
            EndDate:0,
            SearchBy:SearchBy.ConfirmationNumber,
            StartDate:0,
            IsBusy:false,
            SpecificDate:0,
            Reservations:[]
        };
    }

    public render() {
        return (
            <div className={'rednao'} style={{padding:10}}>
                <div>
                    <SearchableSelect Label={'Search By'} Value={this.state.SearchBy} onChange={x=>this.setState({SearchBy:x as any})} style={{display:'inline-block',width:230,marginRight:10}}>
                        <option value={SearchBy.ConfirmationNumber}>Confirmation Number</option>
                        <option value={SearchBy.ArrivalDateRange}>Arrival Date Range</option>
                        <option value={SearchBy.DepartureDateRange} >Departure Date Range</option>
                        <option value={SearchBy.ArrivalDate}>Arrival Date</option>
                        <option value={SearchBy.DepartureDate} >Departure Date</option>
                    </SearchableSelect>

                    {this.state.SearchBy==SearchBy.ConfirmationNumber&&
                        <RNTextInput Label={'Confirmation Number'} Value={this.state.ConfirmationNumber} onChange={x=>this.setState({ConfirmationNumber:x})} style={{display:'inline-block',width:230,marginRight:10}}/>
                    }

                    {(this.state.SearchBy==SearchBy.ArrivalDate||this.state.SearchBy==SearchBy.DepartureDate)&&
                    <RNDatePicker Label={this.state.SearchBy==SearchBy.ArrivalDate?'Arrival Date':'Departure Date'} Value={this.state.SpecificDate} onChange={x=>this.setState({SpecificDate:x as any})} style={{display:'inline-block',marginRight:10}}/>
                    }

                    {(this.state.SearchBy==SearchBy.ArrivalDateRange||this.state.SearchBy==SearchBy.DepartureDateRange)&&
                        <RNDatePicker Label={'Start Date'} Value={this.state.StartDate} onChange={x=>this.setState({StartDate:x as any})} style={{display:'inline-block',marginRight:10}}/>
                    }

                    {(this.state.SearchBy==SearchBy.ArrivalDateRange||this.state.SearchBy==SearchBy.DepartureDateRange)&&
                        <RNDatePicker Label={'End Date'} Value={this.state.EndDate} onChange={x=>this.setState({EndDate:x as any})} style={{display:'inline-block',marginRight:10}}/>
                    }

                    <SpinnerButton IsBusy={this.state.IsBusy} OnClick={()=>this.Search()} Icon={faSearch} AddLabelMargin={true}>Search</SpinnerButton>

                </div>

                <div style={{marginTop:15}}>
                    {this.state.Reservations.map(reservation=>
                        <div key={reservation.Id} style={{backgroundColor:'white',padding:10,borderRadius:10,marginBottom:20,border:'1px solid #dfdfdf'}}>
                            <div className={'rncontrol '}>
                                <label>Confirmation Number</label>
                                <input type={'text'} value={reservation.confirmation_number} disabled={true}/>
                            </div>

                            <div className={'rncontrol '}>
                                <label>Agreement Number</label>
                                <input type={'text'} value={reservation.agreement_number} disabled={true}/>
                            </div>

                            <div className={'rncontrol '}>
                                <label>Arrival Date</label>
                                <input type={'text'} value={reservation.arrival_date} disabled={true}/>
                            </div>

                            <div className={'rncontrol '}>
                                <label>Departure Date</label>
                                <input type={'text'} value={reservation.departure_date} disabled={true}/>
                            </div>

                            <div className={'rncontrol '}>
                                <label>Hotel Name</label>
                                <input type={'text'} value={reservation.hotel_name} disabled={true}/>
                            </div>

                            <div className={'rncontrol '}>
                                <label>Member Name</label>
                                <input type={'text'} value={reservation.member_name} disabled={true}/>
                            </div>

                            <div className={'rncontrol '}>
                                <label>Room Number</label>
                                <input type={'text'} value={reservation.room_number} disabled={true}/>
                            </div>

                            <div className={'rncontrol '}>
                                <label>Total Pax</label>
                                <input type={'text'} value={reservation.total_pax} disabled={true}/>
                            </div>
                        </div>

                    )}
                </div>
            </div>
        )
    }

    private async Search() {
        let search:any={api_key:'$2y$10$mvu0wptrAM0rYLnpG/K2..xjvyduTz7OsoifjwfzjPY6KzwG7oXC2'};
        if(this.state.SearchBy==SearchBy.ConfirmationNumber) {
            search.confirmation_number = this.state.ConfirmationNumber;
        }

        if(this.state.SearchBy==SearchBy.ArrivalDateRange||this.state.SearchBy==SearchBy.DepartureDateRange)
        {
            if(this.state.StartDate==0||this.state.EndDate==0)
            {
                ToastService.SendErrorMessage('Start and end date is mandatory');
                return;
            }

            search.source=this.state.SearchBy==SearchBy.DepartureDateRange?'departure':'arrival';
            search.start_date=moment.unix(this.state.StartDate+(new Date().getTimezoneOffset()*60)).format('YYYY-MM-DD');
            search.end_date=moment.unix(this.state.EndDate+(new Date().getTimezoneOffset()*60)).format('YYYY-MM-DD');


        }

        if(this.state.SearchBy==SearchBy.DepartureDate||this.state.SearchBy==SearchBy.ArrivalDate)
        {
            if(this.state.SpecificDate==0||this.state.SpecificDate==0)
            {
                ToastService.SendErrorMessage('Date is mandatory');
                return;
            }
            let value=moment.unix(this.state.SpecificDate+(new Date().getTimezoneOffset()*60)).format('YYYY-MM-DD')

            if(this.state.SearchBy==SearchBy.ArrivalDate)
                search.arrival_date=value;

            if(this.state.SearchBy==SearchBy.DepartureDate)
                search.departure_date=value;



        }

        this.setState({IsBusy:true});
        let result:Reservation[]=await WpAjaxPost.ExternalPost('https://evolution.lhvcinfo.com/api/v1/reservation/confirmation',search,{OnError:()=>{}});
        if(result==null)
        {
            this.setState({Reservations:[],IsBusy:false});
            return;
        }
        this.setState({IsBusy:false});

        if(!Array.isArray(result))
            result=[result];

        result=result.sort((a, b) => a.confirmation_number.localeCompare(b.confirmation_number));

        let reservationList:Reservation[]=[];

        for(let i=0;i<result.length;i++)
        {
            let currentReservation=new Reservation();
            currentReservation.Id=i;
            currentReservation.agreement_number=result[i].agreement_number;
            currentReservation.arrival_date=result[i].arrival_date;
            currentReservation.confirmation_number=result[i].confirmation_number;
            currentReservation.departure_date=result[i].departure_date;
            currentReservation.hotel_name=result[i].hotel_name;
            currentReservation.member_name=result[i].member_name;
            currentReservation.room_number=result[i].room_number;
            currentReservation.total_pax=result[i].total_pax;
            reservationList.push(currentReservation);
        }

        this.setState({Reservations:reservationList});
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface AppProps {

}

interface AppState {

    SearchBy:SearchBy;
    ConfirmationNumber:string;
    StartDate:number;
    EndDate:number;
    SpecificDate:number;
    IsBusy:boolean;
    Reservations:Reservation[];
}

export class Reservation {
    Id:number;
    agreement_number:string;
    arrival_date:string;
    confirmation_number:string;
    departure_date:string;
    hotel_name:string;
    member_name:string;
    room_number:string;
    total_pax:string;


}
//#endregion "My Region"

/*

       <WPTable Data={this.state.Reservations} EmptyContent={'No records to display'}>
                        <WPBasicColumn Title={'Confirmation Number'} PropertyName={'confirmation_number'}/>
                        <WPBasicColumn Title={'Agreement Number'} PropertyName={'agreement_number'}/>
                        <WPBasicColumn Title={'Arrival Date'} PropertyName={'arrival_date'}/>
                        <WPBasicColumn Title={'Departure Date'} PropertyName={'departure_date'}/>
                        <WPBasicColumn Title={'Hotel Name'} PropertyName={'hotel_name'}/>
                        <WPBasicColumn Title={'Member Name'} PropertyName={'member_name'}/>
                        <WPBasicColumn Title={'Room Number'} PropertyName={'room_number'}/>
                        <WPBasicColumn Title={'Total Pax'} PropertyName={'total_pax'}/>
                    </WPTable>
 */